import ToolCard from "../components/ToolCard";

// components/SubtaskSection.js
const SubtaskSection = ({ result, index }) => {
  return (
    <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
    
      <div className="bg-indigo-50 px-6 py-4 border-b border-indigo-100">
        <h2 className="text-xl font-semibold text-indigo-800 flex items-center">
          <span className="bg-indigo-100 text-indigo-600 rounded-full w-8 h-8 flex items-center justify-center mr-3 text-sm font-bold">
            {index + 1}
          </span>
          {result.subtask}
        </h2>
      </div>
      
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {result.tools.map((tool) => (
            <ToolCard key={tool._id} tool={tool} />
          ))}
        </div>
      </div>

    </div>
  );
};

export default SubtaskSection;